module.exports = __webpack_public_path__ + "img/PhiBetaSig1995.92ea98cc.jpg";